(()=>{
  const API='https://massagomme-renthub-bridge.vercel.app/api/availability';
  const WHATSAPP_NUMBER='393318538663';
  const DAILY_RATE=30;
  const WEEK_DAYS=7;
  const PANDA_IMAGE='https://cdn.shopify.com/s/files/1/0869/1875/8733/files/fiat-panda-massagomme-rent-private-reale.jpg?v=1788161900';
  const DISCOVERY_KEY='massagomme:rent-private-panda:v1';

  const track=(name,params={})=>{if(typeof window.gtag==='function')window.gtag('event',name,params);};
  const pad=n=>String(n).padStart(2,'0');
  const dateValueUTC=ts=>{
    const d=new Date(ts);
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth()+1)}-${pad(d.getUTCDate())}`;
  };
  const todayValue=()=>{
    const d=new Date();
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
  };
  const parseDate=value=>{
    if(!value)return null;
    const [y,m,d]=String(value).split('-').map(Number);
    if(!y||!m||!d)return null;
    return Date.UTC(y,m-1,d);
  };
  const addDays=(value,days)=>{
    const ts=parseDate(value);
    return ts===null?'':dateValueUTC(ts+(days*86400000));
  };
  const formatDateIT=value=>{
    if(!value)return '';
    const [y,m,d]=String(value).split('-');
    return `${d}/${m}/${y}`;
  };
  const rentalDays=(start,end)=>{
    const a=parseDate(start),b=parseDate(end);
    if(a===null||b===null||b<=a)return null;
    return Math.round((b-a)/86400000);
  };
  const isValidWeeks=days=>Number.isInteger(days)&&days>=WEEK_DAYS&&days%WEEK_DAYS===0;
  const nextWeekBlock=days=>Math.max(WEEK_DAYS,Math.ceil((Number(days)||0)/WEEK_DAYS)*WEEK_DAYS);

  const addAliases=(params,names,value)=>names.forEach(name=>params.set(name,String(value)));
  const buildUrl=(detail,typeId,categoryId)=>{
    const {pickup,pickupTime,returnDate,returnTime}=detail;
    const start=`${pickup} ${pickupTime}`;
    const end=`${returnDate} ${returnTime}`;
    const p=new URLSearchParams();
    addAliases(p,['pickup','pickupDate','pickup_date','startDate','start_date','dateStart','date_start','from','date_from'],pickup);
    addAliases(p,['pickupTime','pickup_time','startTime','start_time','timeStart','time_start','time_from'],pickupTime);
    addAliases(p,['returnDate','return_date','dropoffDate','dropoff_date','endDate','end_date','dateEnd','date_end','to','date_to'],returnDate);
    addAliases(p,['returnTime','return_time','dropoffTime','dropoff_time','endTime','end_time','timeEnd','time_end','time_to'],returnTime);
    addAliases(p,['start','start_datetime','datetime_start','pickup_datetime','from_datetime'],start);
    addAliases(p,['end','end_datetime','datetime_end','dropoff_datetime','to_datetime'],end);
    addAliases(p,['location','locationId','location_id','pickupLocation','pickup_location','pickup_location_id','pickupLocationId','startLocation','start_location','start_location_id','startLocationId','location_start','location_start_id','from_location','location_from','locationFrom','locationFromId'],1);
    addAliases(p,['dropoffLocation','dropoff_location','dropoff_location_id','dropoffLocationId','endLocation','end_location','end_location_id','endLocationId','location_end','location_end_id','to_location','location_to','locationTo','locationToId'],1);
    addAliases(p,['type','typeId','type_id','vehicleType','vehicle_type','vehicle_type_id'],typeId);
    addAliases(p,['category','categoryId','category_id','vehicleCategory','vehicle_category','vehicle_category_id'],categoryId);
    addAliases(p,['age','driverAge','driver_age'],30);
    addAliases(p,['lang','language'],'it_IT');
    return `${API}?${p.toString()}`;
  };
  const rowText=row=>[
    row?.model_details?.name,row?.model_details?.model,row?.model_details?.brand,
    row?.model_name,row?.modelName,row?.name
  ].filter(Boolean).join(' ').toLowerCase();
  const findPanda=rows=>(Array.isArray(rows)?rows:[]).find(row=>/\bpand(?:a|ina)\b/i.test(rowText(row)))||null;
  const fetchCategory=async(detail,typeId,categoryId)=>{
    const response=await fetch(buildUrl(detail,typeId,categoryId),{headers:{Accept:'application/json'},cache:'no-store'});
    if(response.status===422)return null;
    if(!response.ok)throw new Error(`RENTHUB_HTTP_${response.status}`);
    const payload=await response.json();
    if(payload?.ok!==true)return null;
    const rows=payload?.data?.result?.vehicles;
    if(!Array.isArray(rows))return null;
    return {rows,payload};
  };
  const readCachedDiscovery=()=>{
    try{
      const value=JSON.parse(sessionStorage.getItem(DISCOVERY_KEY)||'null');
      return value&&Number(value.typeId)&&Number(value.categoryId)?value:null;
    }catch(e){return null;}
  };
  const saveDiscovery=value=>{try{sessionStorage.setItem(DISCOVERY_KEY,JSON.stringify(value));}catch(e){}};
  const checkPandaAvailability=async detail=>{
    const cached=readCachedDiscovery();
    const attempts=[];
    if(cached)attempts.push([cached.typeId,cached.categoryId]);
    for(let categoryId=1;categoryId<=10;categoryId++){
      if(!cached||cached.typeId!==1||cached.categoryId!==categoryId)attempts.push([1,categoryId]);
    }
    for(const [typeId,categoryId] of attempts){
      let result;
      try{result=await fetchCategory(detail,typeId,categoryId);}catch(error){continue;}
      if(!result)continue;
      const row=findPanda(result.rows);
      if(!row)continue;
      const modelId=Number(row?.model_id??row?.model_details?.id)||null;
      saveDiscovery({typeId,categoryId,modelId});
      return {found:true,available:row?.available===true,modelId,row,typeId,categoryId};
    }
    return {found:false,available:null};
  };
  window.MASSAGOMME_PRIVATE_RENTHUB_CHECK=checkPandaAvailability;

  const mount=()=>{
    if(document.getElementById('rent-private'))return;
    const anchor=document.getElementById('preventivo')||document.getElementById('size-guide')||document.getElementById('flotta');
    if(!anchor)return;

    const section=document.createElement('section');
    section.className='private-rental-section';
    section.id='rent-private';
    section.innerHTML=`
      <div class="wrap private-rental-wrap">
        <div class="private-rental-head">
          <div><span class="eyebrow">MASSA GOMME RENT PRIVATE</span><h2>NOLEGGIO UTILITARIA</h2><p>Fiat Panda a 30 € al giorno. Noleggio esclusivamente a settimane intere: 7, 14, 21, 28 giorni e multipli.</p></div>
          <span class="private-pricepill">30 € / giorno · 7 giorni = 210 €</span>
        </div>
        <button class="private-car-card" id="private-car-open" type="button" aria-expanded="false" aria-controls="private-rental-flow">
          <span class="private-car-media"><img src="${PANDA_IMAGE}" alt="Fiat Panda reale MassaGomme Rent Private" loading="lazy"><small>FOTO REALE DELLA PANDA MASSAGOMME</small></span>
          <span class="private-car-copy"><span class="private-kicker">UTILITARIA · SENZA CONDUCENTE</span><strong>FIAT PANDA</strong><span class="private-rate">30 € <small>/ giorno</small></span><b>7 GIORNI = 210 € · SOLO SETTIMANE INTERE</b><small class="fuel-exclusion">* Carburante escluso</small><span class="private-open-label">CLICCA PER SCEGLIERE LE DATE E VERIFICARE LA DISPONIBILITÀ</span></span>
        </button>
        <div class="private-flow" id="private-rental-flow" hidden>
          <div class="private-form-card">
            <div class="private-form-title"><span>01</span><div><b>Scegli le date</b><small>Puoi prenotare solo 7, 14, 21, 28 giorni o multipli di 7.</small></div></div>
            <div class="private-fields">
              <label>Data ritiro<input id="private-pickup-date" type="date"></label>
              <label>Ora ritiro<input id="private-pickup-time" type="time" value="08:30"></label>
              <label>Data riconsegna<input id="private-return-date" type="date" step="7"></label>
              <label>Ora riconsegna<input id="private-return-time" type="time" value="18:30"></label>
            </div>
            <label class="private-km-field">Chilometri previsti <small>(facoltativo, per completare la richiesta)</small><input id="private-km" type="number" min="1" step="1" inputmode="numeric" placeholder="Es. 500"></label>
            <div class="private-summary">
              <div><span>Durata</span><b id="private-days">7 giorni</b></div>
              <div><span>Tariffa</span><b>30 € / giorno</b></div>
              <div class="private-total"><span>Totale automatico</span><strong id="private-total">210 €</strong></div>
            </div>
            <p class="private-rule" id="private-rule">Scegli il giorno di ritiro: la prima riconsegna possibile sarà esattamente 7 giorni dopo.</p>
            <button class="private-check" id="private-check" type="button">VERIFICA DISPONIBILITÀ PANDA</button>
            <div class="private-live" id="private-live" role="status" aria-live="polite"><span class="private-dot"></span><b>RentHub</b><span id="private-live-text">In attesa delle date.</span></div>
            <a class="btn private-wa" id="private-wa" href="#" target="_blank" rel="noopener">CERCO LA PANDA · INVIA SU WHATSAPP</a>
          </div>
          <div class="private-process-card">
            <span class="eyebrow">Procedura Rent Private</span><h3>COME NOLEGGIARE LA PANDA</h3>
            <ol>
              <li><b>Scegli una settimana intera</b><span>7 giorni = 210 €. Puoi estendere solo a 14, 21, 28 giorni o altri multipli di 7.</span></li>
              <li><b>Verifica la disponibilità</b><span>Il sito prova a leggere in tempo reale la Panda presente in RentHub.</span></li>
              <li><b>Invia i documenti del conducente</b><span>Patente di guida e carta d'identità, in sede oppure via WhatsApp.</span></li>
              <li><b>Conferma e ritira l'auto</b><span>Dopo conferma e pagamento, ritiro presso Via Macallè 72, Seregno.</span></li>
            </ol>
            <div class="private-minimum"><span>NOLEGGIO A SETTIMANE</span><strong>7 GIORNI</strong><b>210 €</b></div>
          </div>
        </div>
      </div>`;

    if(anchor.id==='preventivo')anchor.insertAdjacentElement('afterend',section);
    else anchor.insertAdjacentElement('beforebegin',section);

    const nav=document.querySelector('.navlinks');
    if(nav&&!nav.querySelector('a[href="#rent-private"]')){
      const link=document.createElement('a');
      link.href='#rent-private';
      link.textContent='Utilitaria';
      const waNav=nav.querySelector('.wa');
      nav.insertBefore(link,waNav||null);
    }

    const open=document.getElementById('private-car-open');
    const flow=document.getElementById('private-rental-flow');
    const pickup=document.getElementById('private-pickup-date');
    const pickupTime=document.getElementById('private-pickup-time');
    const ret=document.getElementById('private-return-date');
    const returnTime=document.getElementById('private-return-time');
    const km=document.getElementById('private-km');
    const daysEl=document.getElementById('private-days');
    const totalEl=document.getElementById('private-total');
    const rule=document.getElementById('private-rule');
    const check=document.getElementById('private-check');
    const live=document.getElementById('private-live');
    const liveText=document.getElementById('private-live-text');
    const wa=document.getElementById('private-wa');

    pickup.min=todayValue();
    ret.step=String(WEEK_DAYS);

    const setLive=(state,text)=>{
      live.dataset.state=state;
      liveText.textContent=text;
    };
    const current=()=>{
      const days=rentalDays(pickup.value,ret.value);
      const valid=isValidWeeks(days);
      return {days,valid,total:valid?days*DAILY_RATE:null};
    };
    const setReturnFromPickup=(weeks=1)=>{
      if(!pickup.value)return;
      const days=weeks*WEEK_DAYS;
      ret.min=addDays(pickup.value,WEEK_DAYS);
      ret.step=String(WEEK_DAYS);
      ret.value=addDays(pickup.value,days);
    };
    const snapReturnToWeek=()=>{
      if(!pickup.value||!ret.value)return false;
      const days=rentalDays(pickup.value,ret.value);
      if(isValidWeeks(days))return false;
      const snappedDays=nextWeekBlock(days);
      ret.value=addDays(pickup.value,snappedDays);
      return true;
    };
    const buildMessage=(availabilityText)=>{
      const state=current();
      const kmLine=km.value?`\nKm previsti: ${Math.ceil(Number(km.value))}`:'';
      return `Ciao, ti contatto dal sito www.massagomme.com per MASSA GOMME RENT PRIVATE.\n\nCerco la Fiat Panda senza conducente.\nRitiro: ${formatDateIT(pickup.value)} ore ${pickupTime.value}\nRiconsegna: ${formatDateIT(ret.value)} ore ${returnTime.value}\nDurata: ${state.days} giorni\nTariffa: 30 € al giorno\nTotale automatico: ${state.total} €${kmLine}\nDisponibilità online: ${availabilityText}\n\nVorrei procedere con la prenotazione della Panda.`;
    };
    const updateWhatsApp=(availabilityText='da verificare')=>{
      const state=current();
      if(!state.valid||!state.total){wa.classList.remove('show');wa.href='#';return;}
      wa.href=`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(buildMessage(availabilityText))}`;
      wa.classList.add('show');
    };
    const refresh=(snapped=false)=>{
      if(pickup.value){
        ret.min=addDays(pickup.value,WEEK_DAYS);
        ret.step=String(WEEK_DAYS);
      }
      const state=current();
      if(!pickup.value){
        daysEl.textContent='7 giorni';
        totalEl.textContent='210 €';
        rule.textContent='Scegli il giorno di ritiro: la prima riconsegna possibile sarà esattamente 7 giorni dopo.';
        rule.dataset.ok='false';
        setLive('idle','In attesa delle date.');
        updateWhatsApp();
        return;
      }
      if(!state.days){
        daysEl.textContent='7 giorni';
        totalEl.textContent='210 €';
        rule.textContent='Scegli una data di riconsegna a 7, 14, 21, 28 giorni dal ritiro.';
        rule.dataset.ok='false';
        updateWhatsApp();
        return;
      }
      daysEl.textContent=`${state.days} giorni`;
      if(!state.valid){
        totalEl.textContent='—';
        rule.textContent='Durata non valida: puoi scegliere solamente 7, 14, 21, 28 giorni o multipli di 7.';
        rule.dataset.ok='false';
        setLive('idle','Seleziona una durata a settimane intere.');
        updateWhatsApp();
        return;
      }
      totalEl.textContent=`${state.total} €`;
      const weeks=state.days/WEEK_DAYS;
      rule.textContent=snapped
        ? `Data adattata automaticamente a ${weeks} ${weeks===1?'settimana':'settimane'}: ${state.days} giorni · ${state.total} €.`
        : `${weeks} ${weeks===1?'settimana':'settimane'} · ${state.days} giorni × 30 € = ${state.total} €.`;
      rule.dataset.ok='true';
      setLive('idle','Date valide: premi “Verifica disponibilità Panda”.');
      updateWhatsApp();
    };

    open.addEventListener('click',()=>{
      const opening=flow.hidden;
      flow.hidden=!opening;
      open.setAttribute('aria-expanded',opening?'true':'false');
      if(opening){
        flow.scrollIntoView({behavior:'smooth',block:'start'});
        track('rent_private_open',{vehicle:'Fiat Panda',tariffa:DAILY_RATE,blocco_giorni:WEEK_DAYS});
      }
    });

    pickup.addEventListener('change',()=>{
      if(pickup.value)setReturnFromPickup(1);
      refresh();
    });
    ret.addEventListener('change',()=>{
      const snapped=snapReturnToWeek();
      refresh(snapped);
    });
    pickupTime.addEventListener('change',()=>refresh());
    returnTime.addEventListener('change',()=>refresh());
    km.addEventListener('input',()=>updateWhatsApp());

    check.addEventListener('click',async()=>{
      const state=current();
      if(!state.valid||!state.total){
        rule.textContent='Seleziona una durata valida: 7, 14, 21, 28 giorni o multipli di 7.';
        rule.dataset.ok='false';
        return;
      }
      check.disabled=true;
      setLive('checking','Controllo Panda in tempo reale su RentHub…');
      track('rent_private_availability_check',{vehicle:'Fiat Panda',giorni:state.days,totale:state.total});
      try{
        const result=await checkPandaAvailability({pickup:pickup.value,pickupTime:pickupTime.value||'08:30',returnDate:ret.value,returnTime:returnTime.value||'18:30'});
        if(result.found&&result.available){
          setLive('available','Panda DISPONIBILE per le date selezionate. Puoi inviare la richiesta di conferma.');
          updateWhatsApp('DISPONIBILE su RentHub');
          track('rent_private_available',{vehicle:'Fiat Panda',model_id:result.modelId||0,giorni:state.days,totale:state.total});
        }else if(result.found){
          setLive('unavailable','Panda NON DISPONIBILE per queste date. Puoi scriverci per verificare settimane alternative.');
          updateWhatsApp('NON DISPONIBILE su RentHub');
          track('rent_private_unavailable',{vehicle:'Fiat Panda',model_id:result.modelId||0,giorni:state.days});
        }else{
          setLive('unknown','La Panda non è ancora identificabile automaticamente nella categoria auto di RentHub. Invia la richiesta e la verifichiamo subito.');
          updateWhatsApp('non verificabile automaticamente');
        }
      }catch(error){
        console.warn('MassaGomme Rent Private availability error',error);
        setLive('unknown','Disponibilità online momentaneamente non verificabile. Puoi comunque inviare la richiesta su WhatsApp.');
        updateWhatsApp('non verificabile online');
      }finally{
        check.disabled=false;
      }
    });

    wa.addEventListener('click',()=>{
      const state=current();
      track('rent_private_whatsapp',{vehicle:'Fiat Panda',giorni:state.days||0,totale:state.total||0});
    });
    refresh();
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setTimeout(mount,0));
  else setTimeout(mount,0);
})();